module.exports = __webpack_public_path__ + "img/ls.5bf3548c.svg";